import { JsxElement } from "typescript";
import "./CurrentTurnBanner.css";
import { useAppSelector } from "./store";
import { ReactElement } from "react";

function CurrentTurnBanner() {
  const players = useAppSelector((state) => {
    return state.players;
  });
  const profile = useAppSelector((state) => {
    return state.profile;
  });
  const game = useAppSelector((state) => {
    return state.game;
  });

  const userIndex = players.findIndex((p) => p.id === profile.id);
  const isUsersTurn = game.currentPlayerIndex === userIndex ? true : false;

  let contents: ReactElement;
  if (isUsersTurn && players.length > 1) {
    contents = (
      <div className="currentTurnBanner centerContainer">It's your turn</div>
    );
  } else {
    contents = <span></span>;
  }

  return (
    <div className="currentTurnBannerContainer centerContainer">{contents}</div>
  );
}

export default CurrentTurnBanner;
